import React from 'react';
import { connect } from 'react-redux'
import { hashHistory, Link } from 'react-router'
import Paper from 'material-ui/Paper';
import {List, ListItem } from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import Message from 'material-ui/svg-icons/communication/email';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import Document from 'material-ui/svg-icons/action/launch';
import Circle from 'material-ui/svg-icons/av/fiber-manual-record';
import Chat from 'material-ui/svg-icons/communication/chat';
import MyAccount from 'material-ui/svg-icons/social/person';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Refresh from 'material-ui/svg-icons/navigation/refresh';
import {Card, CardActions, CardHeader, CardTitle, CardText} from 'material-ui/Card';
import Moment from 'react-moment';
import { resourceApi } from '../../utils/fetchUtil';
import ProviderCard from '../ProviderCard';
import { fireInAppBrowserPlugin } from '../../actions/environmentActions';


class View extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            afterHoursMessage: null,
            initialMessage: "Please enter your message below and we will be with you shortly."
        }
    }

    getContent(message) {
        return {__html: message};
    }

    renderDocumentThumbnail = (id) => {
        
        let config = {
            method: 'get',
            url: `member/document/${id}`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
            return response.data.Url;
        })
        .catch(function (error) {
            console.log(error);
            return "";
        });

    }

    checkIfAfterHours = () => {
        var self = this;
        
        let config = {
            method: 'get',
            url: `member/careguide/active`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
            
            var cga = response.data;

            var initialMessage = "Please enter your message below and we will be with you shortly.";

            if(cga.IsAfterHours) {
                if(!cga.IsAvailable){
                    initialMessage = cga.AfterHoursMessage;
                }
            }
            
            self.setState({ initialMessage: initialMessage });
        });
    }

    renderAttachment = (a) => {
        switch(a.AttachmentTypeID) {

            case 1:
                // Hyperlink
                return (
                    <div>
                        <a style={{ textDecoration:"none"}} rel="noopener noreferrer" onClick={()=>{fireInAppBrowserPlugin(a.Value)}} style={{color:'#ffffff', textDecoration: 'underline'}}>{a.Name}</a>
                        <br />
                    </div>
                );
                break;
                case 2:
                // Internal Link
                return (
                    <div>
                        - {a.Name} Link -
                        {/* <Link to={a.Value} >{a.Name}</Link> */}
                        <br />
                    </div>
                );
                break;
            case 3:
                //Phone
                return (
                    <div>
                        <a style={{ textDecoration:"none"}} onClick={()=>{fireInAppBrowserPlugin("tel:" + a.Value)}} style={{color:'#ffffff', textDecoration: 'underline'}}>{a.Name}</a>
                        <br />
                    </div>
                );
                break;
            case 4:
                //Images/Documents
                return (
                    <div style={{backgroundClip: 'border-box', textAlign:'center',  backgroundSize:'cover'}}>
                        {/* , background: "url('" + a.Document.Url + "')" */}
                        <img src={a.Document.Url} style={{height: 150, margin:'0 auto'}} onClick={() => this.props.viewDocument(a.Document.ClientUserDocumentID)} />
                    </div>
                );
            case 5:
                // Provider ID
                // return (
                //     <div style={{margin:20}}>
                //         <ProviderCard providerId={a.ProviderID} />
                //     </div>
                // );
                break;
            case 6:
                // Custom?
                break;
        }
    }
        
    getImagesOffset = () => {

        var count = this.props.message.replies.filter((r) => {
            return (r.Attachment && r.Attachment.AttachmentTypeID == 4);
        }).length;

        return (count * 150);
    }

    render() {
        
        const styles = { 
            blue: {
                backgroundColor: "#4297fd",
                //window.muiTheme.palette.primary1Color,
                //'#00BCD4', // need to reference the theme here and apply the primary1 color.
                color:"#ffffff",
                marginTop:15,
                padding:15,
                fontSize:14,
                borderRadius: 5,
                //width:'80%',
                float:'right',
                textAlign:'left',
                fontWeight:100
            },
            gray: 
            {
                backgroundColor: '#DCDCDB',
                color:"#515151",
                marginTop:15,
                padding:15,
                fontSize:14,
                borderRadius: 5,
                //width:'80%',
                float:'left',
                textAlign:'left',
                fontWeight:100
            }
        }

        return (
            <div>
                {this.props.message && (
                    <div>
                        {this.props.message.SystemMessageTypeID === 1 && (
                            <Card>
                                <CardHeader
                                    title={this.props.message.Subject}
                                    style={{padding:16, width:"90%"}}
                                    avatar={(this.props.message.IsMyReply ? <Avatar icon={<MyAccount />} style={{backgroundColor:"#666666"}} /> : <Avatar> <div className="care-guide-small" /> </Avatar> ) } 
                                />
                                <CardText>
                                    <div style={{fontSize:16}}  dangerouslySetInnerHTML={this.getContent(this.props.message.Message)} />
                                </CardText>
                            </Card>
                        )}
                        <div id="divNext" style={{height: 'auto'}}>
                            {this.props.message.replies && this.props.message.replies.map((item, index) => (
                                <div key={index} id={"messageNumber" + index} >
                                    {item.Attachment && item.Attachment.ProviderID && (
                                        <div style={{margin:20}}>
                                            <ProviderCard providerId={item.Attachment.ProviderID} />
                                        </div>
                                    )}

                                    {((!item.Attachment) || (item.Attachment && !item.Attachment.ProviderID)) && (
                                        <div key={index} style={(item.IsMyReply ? styles.gray : styles.blue)}>

                                            {item.Attachment && (
                                                this.renderAttachment(item.Attachment)
                                            )}

                                            {!item.Attachment && (
                                                <div style={{fontSize:16, fontWeight:100, width:270}} dangerouslySetInnerHTML={this.getContent(item.Message)} />    
                                            )}

                                            <br />
                                            <span style={{fontSize:12}}>{ 
                                                item.DateSent
                                            }</span>
                                        </div>
                                    )}
                                    
                                    {item.CgAvatar && (
                                        <div style={{float:'right', textAlign: 'center', padding:'25px 7px 0 0'}}>
                                            <div>
                                                <img  style={{top:20, height:30, width:30,  borderRadius: '50%'}} src={item.CgAvatar} /> 
                                            </div>
                                            <div><span style={{fontSize:10}} >{item.CgName}</span></div>
                                        </div>
                                    )}
                                    <div style={{ clear: 'both'}}></div>
                                    {(index === (this.props.message.replies.length - 1)) && (
                                        <div>
                                            <div id="divFaker" style={{height: 130}} ></div>
                                            <div id="endOfChat" style={{height:1, clear: "both"}} >&nbsp;</div>
                                       </div>
                                    )}
                                </div>
                            ))}

                            {(this.props.message.SystemMessageID === 0 || this.props.message.AllowsReplies) && !this.props.message.replies && (
                                <p style={{color:'#999999', textAlign: 'center', margin:30, marginTop:115 }}>
                                    {this.state.initialMessage}
                                </p>
                            )}

                            <div style={{ clear: "both", height: 150 }}></div>
                            
                            {/* <div id="endOfChat" style={{ display:'block',height: (100 + this.getImagesOffset)}}></div> */}
                        </div>
                    </div>
                )}
                {!this.props.message && (
                    <p>No message selected</p>
                )}
                <br />
                <br />
            </div>
        );
    }
};

export default View;


// WEBPACK FOOTER //
// ./src/Components/Messaging/View.js